module.exports = __webpack_public_path__ + "img/ios.b7733a81.svg";